import { openModal } from '../../modal';

/*
	Po wysłaniu formularza kontaktowego pokazujemy podziękowanie w modalu
	(_partials/kontakt-modal.html.twig), a formularz zostaje na stronie — wyczyści go
	ajax-form.js zaraz po tym zdarzeniu.
*/
$('.contact-form').on('submit-success', function(event, data, xhr) {
    event.assert(xhr.status == 201 && data.status == 'OK');

    openModal(document.querySelector('[data-modal="kontakt-dziekujemy"]'));
});
